'use client';
import { ReactNode } from 'react';
import { ReloadIcon } from '@radix-ui/react-icons';
import { Button } from './Button';

export type ReloadButtonProps = {
  onReload?: () => Promise<boolean>;
  className?: string;
  children?: ReactNode;
};

export default function ReloadButton({ onReload, className, children }: ReloadButtonProps) {
  const handleReload = async () => {
    await onReload?.();
  };

  return (
    <Button className={className} variant="outline" size="sm" onClick={handleReload}>
      <ReloadIcon className="h-4 w-4" />
      {children && <div className="inline-block ml-2">{children}</div>}
    </Button>
  );
}
